import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Breadcrumb Component with Parallax Background
 * @param {string} heading - The page title text.
 * @param {Array} links - Array of navigation points: [{ label: 'Home', url: '/' }, { label: 'Products' }]
 * @param {string} bgImage - Background image URL (optional, has a default)
 * @param {number} overlayOpacity - Tint overlay opacity 0-100 (optional, default 50)
 */
function Breadcrumb({
  heading = "Page Title",
  links = [
    { label: "Home", url: "/" },
    { label: "Current Page" }
  ],
  bgImage = "https://img.magnific.com/free-photo/loaded-circuit-board_1384-31.jpg?semt=ais_hybrid&w=740&q=80",
  overlayOpacity = 50
}) {
  return (
    <div
      className="relative w-full h-64 flex flex-col justify-center bg-cover bg-center md:bg-fixed"
      style={{ backgroundImage: `url('${bgImage}')` }}
    >
      {/* Dark tint overlay for text legibility */}
      <div
        className="absolute inset-0 bg-black"
        style={{ opacity: overlayOpacity / 100 }}
      />

      {/* Content wrapper */}
      <div className="relative max-w-7xl w-full mx-auto px-6 z-10">

        {/* Navigation links */}
        <nav className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-gray-300 mb-3">
          {links.map((link, index) => {
            const isLast = index === links.length - 1;

            return (
              <div key={index} className="flex items-center gap-2">
                {isLast ? (
                  <span className="text-gray-400">{link.label}</span>
                ) : (
                  <Link to={link.url || "/"} className="hover:text-white transition-colors">
                    {link.label}
                  </Link>
                )}
                {!isLast && <span className="text-gray-500">/</span>}
              </div>
            );
          })}
        </nav>

        {/* Main Heading */}
        <h1 className="text-3xl font-bold text-white tracking-tight">
          {heading}
        </h1>

      </div>
    </div>
  );
}

export default Breadcrumb;